import React, { useEffect, useState } from 'react';
import './ProviderAccountForm.scss';
import { http, FxSelect, localstorage, formatService, AlertService, FxInput } from '../../fx-core';
import { Button, IconButton } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CloseIcon from '@material-ui/icons/Close';
import * as _ from 'lodash';
import useRazorpay from '../../utils/useRazorPay';

const ProviderAccountForm = (props) => {
    const Razorpay = useRazorpay();

    const defaultItem = {
        paymentModeId: 2, // 2-Account Transfer (default)
        amount: 500,
        couponCode: "",
        remainingAmount: 500,
        couponValid: false,
        couponData: null
    };
    
    const defaultAmountDetails = [
        { code: "100", text: 100, symbol: "INR " },
        { code: "300", text: 300, symbol: "INR " },
        { code: "500", text: 500, symbol: "INR " },
        { code: "1000", text: 1000, symbol: "INR " }
    ];
    
    const [paymentMode, setPaymentMode] = useState([]);
    const [filteredPaymentMode, setFilteredPaymentMode] = useState([]);
    const [item, setItem] = useState(defaultItem);
    const [amountDetails, setAmountDetails] = useState(defaultAmountDetails);
    const [selAmtCode, setSelAmtCode] = useState("500");

    const initLookup = () => {
        let inputData = {
            lookups: {
                PaymentMode: { default: true }
            },
            filters: {}
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            const allPaymentModes = response.data.PaymentMode;
            const filtered = allPaymentModes.filter(mode => mode.id === 2 || mode.id === 3);
            setPaymentMode(allPaymentModes);
            setFilteredPaymentMode(filtered);
        });
    };

    const handleClose = (res: any = {}) => {
        props.closeProviderAccountForm(res);
    };

    const handleInputChange = (item) => {
        setItem(prevState => ({ ...prevState, [item.name]: item.value }));
    };

    const onAmountSelect = (itemObj) => {
        setSelAmtCode(itemObj.code);
        setItem({
            paymentModeId: 2,
            amount: itemObj.text,
            couponCode: "",
            remainingAmount: itemObj.text,
            couponValid: false,
            couponData: null
        });
    };

    const applyCoupon = () => {
        if (!item.couponCode) {
            AlertService.showErrorMsg("Please enter coupon code.");
            return;
        }

        let inputData = {
            couponCode: item.couponCode,
            amount: item.amount,
            FeatureCouponType: 3
        };
        
        let apiOptions = {
            url: `coupon/validate`,
            data: inputData
        };
        
        http.post(apiOptions).then(res => {
            if (res.data) {
                const couponData = res.data;

                let discount = couponData.discountAmount;
                let remaining = couponData.remainingAmount;

                // Fix wrong backend percent handling
                if (couponData.couponType === "Percent") {
                    discount = (item.amount * couponData.discountAmount) / 100;
                    remaining = item.amount - discount;
                }

                setItem(prev => ({
                    ...prev,
                    couponValid: true,
                    couponData: couponData,
                    remainingAmount: remaining
                }));

                if (remaining <= 0) {
                    AlertService.showSuccessMsg("Coupon applied! Full 100% covered.");
                } else {
                    AlertService.showSuccessMsg(
                        `Coupon applied! Discount: ₹${discount}. Pay remaining: ₹${remaining}`
                    );
                }
            }
        }).catch(error => {
            AlertService.showErrorMsg("Invalid coupon code.");
        });
    };

    const removeCoupon = () => {
        setItem(prevState => ({
            ...prevState,
            couponCode: "",
            couponValid: false,
            couponData: null,
            remainingAmount: prevState.amount
        }));
        AlertService.showSuccessMsg("Coupon removed.");
    };

    const saveAccountCredit = () => {
        if (item.amount === 0) {
            AlertService.showErrorMsg("Please select amount.");
            return;
        }

        if (item.couponValid && item.remainingAmount === 0) {
            submitWithCouponOnly();
            return;
        }

        if (item.paymentModeId === -1 || !item.paymentModeId) {
            AlertService.showErrorMsg("Please select payment mode.");
            return;
        }

        submitAccountCredit();
    };

    const submitWithCouponOnly = () => {
        const account = {
            userId: localstorage.getItem("userId"),
            communityId: localstorage.getItem("communityId")
        };
        
        const accountDetail = {
            userId: localstorage.getItem("userId"),
            transactionDate: formatService.getCurrentDateForServer(),
            paymentModeId: 4,
            paymentMode: "coupon",
            amount: item.amount,                    // FIXED: Original selected amount
            originalAmount: item.amount,            // FIXED: Original selected amount
            couponCode: item.couponCode
        };
        
        let inputData = { account, accountDetail };
        let apiOptions = { url: `account/provider/save`, data: inputData };
        
        http.post(apiOptions).then(res => {
            AlertService.showSuccessMsg("Credits added successfully with coupon!");
            handleClose({ id: res.data, paymentMode: "coupon", refresh: true });
        }).catch(error => {
            AlertService.showErrorMsg("Failed to add credits.");
        });
    };

const submitAccountCredit = () => {
    const account = {
        userId: localstorage.getItem("userId"),
        communityId: localstorage.getItem("communityId")
    };
    
    let selPayMode = _.find(paymentMode, { id: item.paymentModeId });
    
    const accountDetail = {
        userId: localstorage.getItem("userId"),
        transactionDate: formatService.getCurrentDateForServer(),
        paymentModeId: item.paymentModeId,
        paymentMode: selPayMode.code,
        amount: item.amount,                    // ALWAYS original selected amount (₹1000)
        payableAmount: item.remainingAmount,    // Amount to charge for payment (₹500 after coupon)
        couponCode: item.couponValid ? item.couponCode : ""
    };
    
    let inputData = { account, accountDetail };
    let apiOptions = { url: `account/provider/save`, data: inputData };
    
    http.post(apiOptions).then(res => {
        if (selPayMode.code === "razorpay") {
            initiatePayment(res.data, item.remainingAmount); // Send remaining amount to Razorpay
        } else {
            AlertService.showSuccessMsg("Request submitted successfully!");
            handleClose({ id: res.data, paymentMode: selPayMode.code, refresh: true });
        }
    }).catch(error => {
        AlertService.showErrorMsg("Failed to submit request.");
    });
};

const initiatePayment = (accountDetailId, payableAmount) => {
    let inputData = {
        entityTypeId: 3,
        entityId: accountDetailId,
        payableAmount: payableAmount  // Send the remaining amount to charge
    };
    
    http.post({ url: `payment/GetPaymentLink`, data: inputData })
        .then(res => {
            if (res.data && res.data.result) {
                openPaymentLink(res);
            } else {
                AlertService.showErrorMsg("Payment initialization failed.");
            }
        })
        .catch(error => {
            AlertService.showErrorMsg("Failed to initiate payment.");
        });
};

    const openPaymentLink = (resp) => {
        const paymentData = resp.data.result;
        const options = {
            amount: paymentData.amount,
            description: paymentData.description,
            order_id: paymentData.externalOrderId,
            handler: async (response) => {
                const updateData = {
                    Id: paymentData.id,
                    ExternalPaymentId: response.razorpay_payment_id,
                    ExternalOrderId: paymentData.externalOrderId
                };
                await http.post({ url: `payment/updatePaymentSuccess`, data: updateData });
                AlertService.showSuccessMsg("Payment Success!");
                handleClose({ id: paymentData.entityId, paymentMode: "razorpay", refresh: true });
            },
            prefill: {
                name: paymentData.providerName,
                email: paymentData.email,
                contact: paymentData.mobile
            }
        };

        const rzp1 = new Razorpay(options);
        rzp1.on("payment.failed", (response) => {
            AlertService.showErrorMsg("Payment failed. Please try again.");
        });
        rzp1.open();
    };

    useEffect(() => {
        initLookup();
    }, []);

    const showPaymentOptions = !(item.couponValid && item.remainingAmount === 0);

    return (
        <div>
            <div className="row justify-content-between title-font py-1 mx-auto px-3">
                <div className="py-1"><span>Account Form</span></div>
                <div className="float-right pointer" onClick={handleClose}>
                    <HighlightOffIcon fontSize="small" color="secondary" />
                </div>
            </div>
            
            <div className="m-4">
                {/* Amount Selection */}
                <div className='m-1 row'>
                    {amountDetails.map((amt, i) => (
                        <div key={i} className="m-1">
                            <Button 
                                variant="contained" 
                                size="medium" 
                                color={selAmtCode === amt.code ? "primary" : "secondary"} 
                                onClick={() => onAmountSelect(amt)}
                            >
                                <span className='amount'>{amt.symbol}{amt.text}</span>
                            </Button>
                        </div>
                    ))}
                </div>

                {/* Coupon Section */}
                <div className='m-1 pt-3'>
                    <div className="row align-items-end">
                        <div className="col-8">
                            <FxInput 
                                name="couponCode" 
                                variant="outlined" 
                                label="Coupon Code" 
                                fullWidth 
                                size="small"
                                value={item.couponCode} 
                                onValueChange={handleInputChange} 
                                disabled={item.couponValid}
                            />
                        </div>
                        <div className="col-4">
                            {!item.couponValid ? (
                                <Button variant="contained" color="primary" fullWidth onClick={applyCoupon}>
                                    Apply
                                </Button>
                            ) : (
                                <Button variant="outlined" color="secondary" fullWidth onClick={removeCoupon}>
                                    Remove
                                </Button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Amount Summary */}
                {item.couponValid && (
                    <div className='m-1 pt-2'>
                        <div className="alert alert-info py-2 position-relative">
                            <IconButton 
                                size="small" 
                                className="position-absolute" 
                                style={{ top: 5, right: 5 }}
                                onClick={removeCoupon}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                            <strong>Original Amount:</strong> ₹{item.amount}<br/>
                            <strong>Coupon Discount:</strong> ₹{item.amount - item.remainingAmount}<br/>
                            {item.remainingAmount > 0 && (
                                <strong>Amount to Pay: ₹{item.remainingAmount}</strong>
                            )}
                            {item.remainingAmount === 0 && (
                                <strong className="text-success">Fully covered by coupon!</strong>
                            )}
                        </div>
                    </div>
                )}

                {/* Payment Options */}
                {showPaymentOptions && (
                    <>
                        <div className="m-1 pt-3">
                            <FxSelect 
                                name="paymentModeId" 
                                variant="outlined" 
                                label="Payment Mode"
                                options={filteredPaymentMode}
                                selectedValue={item.paymentModeId}
                                valueField="id"
                                displayField="text"
                                size="small"
                                fullWidth
                                onValueChange={handleInputChange} 
                            />
                        </div>
                        
                        {item.paymentModeId === 2 && (
                            <div className='m-1 pt-3'>
                                <div><strong>Bank Transfer Details:</strong></div>
                                <div>A/C No: 50200095946891</div>
                                <div>Name: AOTEAROA SOLUTIONS PVT LTD</div>
                                <div>IFSC: HDFC0002231</div>
                                <div>Branch: SARAVANAMPATTI BRANCH</div>
                                <div>Account Type: CURRENT</div>
                                <div className='mt-2 text-danger'>
                                    Transfer ₹{item.remainingAmount} and submit.
                                </div>
                            </div>
                        )}
                        
                        {item.paymentModeId === 3 && (
                            <div className='m-1 pt-3 text-info'>
                                Pay ₹{item.remainingAmount} via Razorpay
                            </div>
                        )}
                    </>
                )}

                {/* Submit Button */}
                <div className="m-1 pt-3 text-center">
                    <Button variant="contained" size="medium" color="primary" onClick={saveAccountCredit}>
                        {item.couponValid && item.remainingAmount === 0 ? 'Add Credits' : 'Submit'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ProviderAccountForm;